// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"er-z","outfitFeedbackSection":"fr-z"};